<template>
  <div>
    <ConditionalArea @conditions="onConditions"></ConditionalArea>
    <div
      v-if="Object.keys(purchaseList).length == 0"
      class="dxy"
      style="margin-top:30px;"
    >
      加载中...
    </div>
    <div v-else>
      <Details @back="onBack" v-if="Object.keys(purchaseItem).length != 0" :purchaseItem="purchaseItem"></Details>
      <PurchaseList @detail="onDetail" v-else :purchaseList="purchaseList"></PurchaseList>
    </div>
  </div>
</template>
<script>
import ConditionalArea from "./ConditionalArea.vue";
import PurchaseList from "./PurchaseList.vue";
import Details from "./Details.vue";
import * as Api from "../api/index";
export default {
  name: "Layout",
  components: { ConditionalArea, PurchaseList, Details },
  data() {
    return {
      purchaseList: {},
      purchaseItem: {},
    };
  },
  created() {
    this._makeover_api_buying_query({
      category_id: "",
      city_id: "",
      page: "1",
      page_size: "20",
      province_id: "",
      region_id: "",
    });
  },
  methods: {
    onDetail(e) {
      this.purchaseItem = e
    },
    onBack() {
      this.purchaseItem = {}
    },
    onConditions(e) {
      this.purchaseList = {};
      this.purchaseItem = {};
      this._makeover_api_buying_query(e);
    },
    async _makeover_api_buying_query(condition) {
      this.purchaseList = await Api.makeover_api_buying_query(condition);
    },
  },
};
</script>
